import { render, staticRenderFns } from "./select-risk-level.vue?vue&type=template&id=12b9da15"
import script from "./select-risk-level.vue?vue&type=script&lang=ts"
export * from "./select-risk-level.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports